import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {InjectedRouter} from 'react-router';
import Radium, { StyleRoot } from 'radium';
import {MajorAccountsSlider} from '../Components/MajorAccountsSlider';
import {NewApparelMajorAccounts} from '../Components/NewApparelMajorAccounts';
import {MajorAccountsFooter} from '../Components/MajorAccountsFooter';
import { MajorAccountsHdr } from '../Components/MajorAccountsHdr';
import {CampusFeedback} from '../FlatPages/CampusFeedback';
import {WhyUs} from '../Components/WhyUs';
import {MajorAccountsGetStarted} from '../Components/MajorAccountsGetStarted';

// URL-safe Base64 decoder function
const urlSafeBase64Decode = (str: string): string => {
    console.log('urlSafeBase64Decode input:', str);
    
    // First, handle URL encoding if present
    let decoded = decodeURIComponent(str);
    console.log('After URL decode:', decoded);
    
    // Replace URL-safe characters back to standard Base64
    decoded = decoded.replace(/-/g, '+').replace(/_/g, '/');
    console.log('After URL-safe conversion:', decoded);
    
    // Add padding if needed to make length a multiple of 4
    while (decoded.length % 4) {
        decoded += '=';
    }
    console.log('After padding:', decoded);
    
    try {
        // Decode using standard atob()
        const result = atob(decoded);
        console.log('Final decoded result:', result);
        console.log('Result length:', result.length);
        return result;
    } catch (error) {
        console.error('Error decoding Base64:', error);
        console.log('Failed to decode:', decoded);
        // If URL-safe Base64 fails, try regular Base64
        try {
            return atob(str);
        } catch (error2) {
            console.error('Regular Base64 also failed:', error2);
            throw error;
        }
    }
};

const homepageStyle : React.CSSProperties = {
    width:'100%',

}
const shopSchoolbtn: React.CSSProperties = {
    backgroundColor:'white',
    color:'#040A5E',
    borderRadius:'20px',
    width:'268px',
    height:'42px',
    display:'flex',
    justifyContent:'center',
    padding:'10px',
    marginTop:'15%',
    cursor:'pointer',
    alignItems:'center',
    border:'none',
    ':hover':{
        backgroundColor:'#040A5E',
        border:'1px solid white',
        color:'white'

    }
}
const viewDesBtn = Object.assign({},shopSchoolbtn,{
    color:'white',
    border:'none',
    backgroundColor:'#3A54B4',
    marginTop:'8%',
    ':hover':{
        border:'1px solid #3A54B4',
        color:'#3A54B4',
        backgroundColor:'white'
    }
});

const viewDesJuly = Object.assign({},viewDesBtn,{
    color:'white',
    backgroundColor:'#D15858',
    ':hover':{
        border:'1px solid #D15858',
        color:'#D15858',
        backgroundColor:'white'
    }
})
const hdrStyle: React.CSSProperties = {
    backgroundImage:'url('+Tgcc.ResolveUrl('~/images/MA_Desk_2400.jpg') + ')',
    backgroundSize:'cover',
    backgroundRepeat:'no-repeat',
    backgroundPosition:'center'
}
const textPanelStyle: React.CSSProperties = {
    color:'#3A54B4',
    fontFamily:'BarlowLight',
    fontSize:'16px',
    textAlign:'center',
    boxSizing:'border-box'
}
const customHdr: React.CSSProperties = {
    fontFamily:'Lulo',
    textAlign:'center'
}
const bannerCtaBtn = Object.assign({}, viewDesBtn, {
    marginTop:'8%'
})
const brdImgDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'row'
}
const brandDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'column',
    alignItems:'center'
}
const brandHdr: React.CSSProperties = {
    fontSize:'40px',
    fontFamily:'Lulo',
    color:'#3A54B4',
    marginBottom:'25px',
    marginTop:'50px'
}
const subbrandHdr: React.CSSProperties = {
    color:'#040A5E',
    fontSize:'18px'
}
const brandImg : React.CSSProperties = {
    height:'465px',
    transition:'transform 250ms',
    cursor:'pointer',
    ':hover': {
        transform:'translateY(-15px)'
    },
}
const viewProds = Object.assign({},viewDesBtn,{
    width:'450px',
    marginBottom:'50px',
    marginTop:'15px',
    height:'50px'
})
const container: React.CSSProperties = {
    backgroundColor:'#3A54B4',
    height:'462px',
    display:'flex',
    color:'white'
}
const corpContainer : React.CSSProperties = {
    backgroundColor:'#B2BDE6',
    display:'flex',
    height:'462px,',
    color:'#273878',
    marginTop:'50px'
}
const eventTitle: React.CSSProperties = {
    fontFamily:'Lulo',
    fontSize:'38px',
}
const corpTitle = Object.assign({},eventTitle,{color:'#273878',textAlign:'center'})

const innerEvent: React.CSSProperties = {
    fontFamily:'BarlowLight',
    width:'32%',
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center',
    marginLeft:'5%',
    fontSize:'16px'
}
const corpDesignDiv = Object.assign({},innerEvent,{marginLeft:'-8%',fontSize:'16px'});
const fourthImg: React.CSSProperties = {
    backgroundImage:'url(' + Tgcc.ResolveUrl('~/images/July4th_Shirts-01.png') + ')',
    backgroundRepeat:'no-repeat',
    height:'462px',
    backgroundSize:'cover',
    width:'63%',
    backgroundPosition:'right'
}
const corpImg: React.CSSProperties = {
    backgroundImage:'url(' + Tgcc.ResolveUrl('~/images/Corp_Designs-01.png') + ')',
    backgroundRepeat:'no-repeat',
    height:'440px',
    backgroundSize:'cover',
    width:'75%',
    backgroundPosition:'left'
}

class Props extends Tgcc.BaseProps{
    ActiveProof: Tgcc.Proof;
}

class _MajorAccounts extends React.Component <Props, any > {
    state = {
        homepage:""
    }

    componentWillMount(){
        if(this.props.location.query.u && this.props.location.query.c){
            console.log('Raw URL parameters:', {
                u: this.props.location.query.u,
                c: this.props.location.query.c
            });
            
            var decodedEmail = urlSafeBase64Decode(this.props.location.query.u);
            
            // Convert spaces back to + characters in the token (URL encoding issue)
            var rawToken = this.props.location.query.c.replace(/ /g, '+');
            console.log('Raw token being sent to backend:', rawToken);
            
            console.log('Values being sent:', {
                email: decodedEmail,
                token: rawToken,
                tokenLength: rawToken.length
            });
            
            this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: {action: Tgcc.DialogAction.ResetPassword, payload: {token: rawToken, email: decodedEmail}}});
        }
    }

    componentDidMount(){
        var tag = document.getElementById('homepage');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    setError = (msg: string) => {
        this.setState({error: msg, isWaiting: false}, () => {
            this.scrollPageToView("TopProofError");
        });
        return false;
    }
    openProofEdit = () => {
        if(this.props.state.LoginData && this.props.state.UserInfo){
            browserHistory.push(Tgcc.Routes.ProofEdit)
        }
        else {
            browserHistory.push(Tgcc.Routes.Register)
        }    
    };
    openProducts = () =>{browserHistory.push(Tgcc.Routes.MajorAccountsProductListView)}
    openNewDesigns = () =>{browserHistory.push(Tgcc.Routes.MajorAccountsDesignListView)}
    openAbout = () =>{browserHistory.push(Tgcc.Routes.About)}
    openNext = () =>{browserHistory.push(Tgcc.Routes.MajorAccountsProductView('Next Level','6210','Ice Blue'))}
    openComf = () =>{browserHistory.push(Tgcc.Routes.MajorAccountsProductView('Comfortwash','GDH100','Cactus'))}
    openPort = () =>{browserHistory.push(Tgcc.Routes.MajorAccountsProductView('Port Authority','C112','Gusty Grey/ Black/ Grey Steel'))}
    openFourth = () =>{browserHistory.push(Tgcc.Routes.MajorAccountsKeyword('america'))}

    
  
    render() {
        return (
                <div style={homepageStyle}>
                    <div id="homepage"></div>
                    <MajorAccountsHdr />
                    <div className="maBannerWrap">
                        <div style={hdrStyle} className="maBannerHdr"></div>
                        <div style={textPanelStyle} className="maTopBanner">
                            <div style={customHdr} className="maBannerTitle">CUSTOM APPAREL,<br/>MADE SIMPLE</div>
                            <div className="maBannerSubtextGroup">
                                <div className="maBannerSubtext">Whether you're ordering for an event, or merch for your company - we've got you covered!</div>
                                <div className="maBannerSubtext">Search by keyword or category to find the perfect design!</div>
                            </div>
                            <div style={bannerCtaBtn} className="maBannerCta" key={1} onClick={this.openNewDesigns}>View NEW Designs</div>
                        </div>
                    </div>
                    <CampusFeedback state={this.props.state} />
                    <div style={brandDiv}>
                        <div style={brandHdr} className="brandWe">STAFF FAVORITES</div>
                        <div style={subbrandHdr}>Trust us - you're gonna love these</div>
                        <div style={brdImgDiv} className="brandPrd">
                            <img key={3} className="prodImg" onClick={this.openNext} style={brandImg} src={Tgcc.ResolveUrl('~/images/6210-01.png')} />
                            <img key={4} className="prodImg" onClick={this.openComf} style={brandImg} src={Tgcc.ResolveUrl('~/images/GDH100_-01.png')} />
                            <img key={5} className="prodImg" onClick={this.openPort} style={brandImg} src={Tgcc.ResolveUrl('~/images/C112-01.png')} />
                        </div>
                        <div style={viewProds} key={2} onClick={this.openProducts}>VIEW ALL PRODUCTS</div>
                    </div>
                    <div style={container} className="eventDesigns">
                        <div style={innerEvent} className="eventDiv">
                            <div style={eventTitle} className="eventTitle">EVENT DESIGNS</div>
                            <div>We love any occasion to celebrate!</div>
                            <div>Customize any design for a Holiday or Event</div>
                            <div>in our Design Gallery</div>
                            <div style={viewDesJuly} key={6} onClick={this.openFourth}>NEW 4th of July Designs</div>
                        </div>
                        <div style={fourthImg} className="eventImg"></div>
                    </div>
                    {/* Corporate Designs Banner - Hidden */}
                    {/* <div style={corpContainer} className="corpDesignCont">
                        <div style={corpImg} className="corpDesignImg"></div>
                        <div style={corpDesignDiv} className="corpDesignDiv">
                            <div style={corpTitle}>CORPORATE DESIGNS</div>
                            <div>Looking to have apparel made with your company logos?</div>
                            <div>No problem! For customers with their logos ready - just</div>
                            <div>upload your logo in the "I Have Art" box!</div>
                            <div style={viewDesBtn} key={7} onClick={this.openProofEdit}>Start Your Order WITH Your Logos</div>
                        </div>
                    </div> */}
                    <MajorAccountsGetStarted />
                    <WhyUs />                                                   
                        <MajorAccountsFooter state={this.props.state} />

                </div>
        );
    }
}


var radiumMajorAccountsPage = Radium(_MajorAccounts);

const mapStateToProps = (state: Tgcc.GlobalState) => { 
    return { ActiveProof: state.ActiveProof,
             state:state}
};
export var MajorAccounts = connect(mapStateToProps)(radiumMajorAccountsPage);



